import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import { menuRootOptions, allowStackToScrollOnWebOption } from '../utils/defaultNavOptions';
import TermsScreen from '../screens/TermsScreen';
import ContactScreen from '../screens/ContactScreen';
import PrivacyScreen from '../screens/PrivacyScreen';
import MyTripsScreen from '../screens/MyTripsScreen';
import MeScreen from '../screens/MeScreen';
import AlertsScreen from '../screens/AlertsScreen';
import SocialScreen from '../screens/SocialScreen';
import ExpenseScreen from '../screens/ExpenseScreen';
import IconScreen from '../screens/IconScreen';

import { Screens } from '../constants/ScreenNames';
import EventHomeScreen from '../screens/Events/EventHomeScreen';

const ContactStackNavigator = createStackNavigator();

export const ContactNavigator = () => {
  return (
    <ContactStackNavigator.Navigator
      screenOptions={(props) => ({ ...menuRootOptions(props), ...allowStackToScrollOnWebOption })}
    >
      <ContactStackNavigator.Screen name={Screens.Contact} component={ContactScreen} />
    </ContactStackNavigator.Navigator>
  );
};

const TermsStackNavigator = createStackNavigator();

export const TermsNavigator = () => {
  return (
    <TermsStackNavigator.Navigator
      screenOptions={(props) => ({ ...menuRootOptions(props), ...allowStackToScrollOnWebOption })}
    >
      <TermsStackNavigator.Screen name={Screens.Terms} component={TermsScreen} />
    </TermsStackNavigator.Navigator>
  );
};

const EventStackNavigator = createStackNavigator();
export const EventNavigator = () => {
  return (
    <EventStackNavigator.Navigator
      screenOptions={(props) => ({ ...menuRootOptions(props), ...allowStackToScrollOnWebOption })}
    >
      <EventStackNavigator.Screen
        name={Screens.EventHome}
        component={EventHomeScreen}
        options={menuRootOptions}
      />
    </EventStackNavigator.Navigator>
  );
};

const PrivacyStackNavigator = createStackNavigator();

export const PrivacyNavigator = () => {
  return (
    <PrivacyStackNavigator.Navigator
      screenOptions={(props) => ({ ...menuRootOptions(props), ...allowStackToScrollOnWebOption })}
    >
      <PrivacyStackNavigator.Screen name={Screens.Privacy} component={PrivacyScreen} />
    </PrivacyStackNavigator.Navigator>
  );
};

const MyTripsStackNavigator = createStackNavigator();

export const MyTripsNavigator = () => {
  return (
    <MyTripsStackNavigator.Navigator
      headerMode="screen"
      screenOptions={allowStackToScrollOnWebOption}
    >
      <MyTripsStackNavigator.Screen name={Screens.MyTrips} component={MyTripsScreen} />
    </MyTripsStackNavigator.Navigator>
  );
};

const MeStackNavigator = createStackNavigator();

export const MeNavigator = () => {
  return (
    <MeStackNavigator.Navigator screenOptions={menuRootOptions}>
      <MeStackNavigator.Screen name={Screens.Me} component={MeScreen} />
    </MeStackNavigator.Navigator>
  );
};

const AlertStackNavigator = createStackNavigator();

export const AlertNavigator = () => {
  return (
    <AlertStackNavigator.Navigator screenOptions={menuRootOptions}>
      <AlertStackNavigator.Screen name={Screens.Alerts} component={AlertsScreen} />
    </AlertStackNavigator.Navigator>
  );
};

const SocialStackNavigator = createStackNavigator();

export const SocialNavigator = () => {
  return (
    <SocialStackNavigator.Navigator screenOptions={menuRootOptions}>
      <SocialStackNavigator.Screen name={Screens.Social} component={SocialScreen} />
    </SocialStackNavigator.Navigator>
  );
};

const ExpenseStackNavigator = createStackNavigator();

export const ExpenseNavigator = () => {
  return (
    <ExpenseStackNavigator.Navigator screenOptions={menuRootOptions}>
      <ExpenseStackNavigator.Screen name={Screens.Expense} component={ExpenseScreen} />
    </ExpenseStackNavigator.Navigator>
  );
};

const IconStackNavigator = createStackNavigator();

export const IconNavigator = () => {
  return (
    <IconStackNavigator.Navigator
      screenOptions={(props) => ({ ...menuRootOptions(props), ...allowStackToScrollOnWebOption })}
    >
      <IconStackNavigator.Screen name="Icon" component={IconScreen} />
    </IconStackNavigator.Navigator>
  );
};
